import { SET_DELIVERY_TYPE } from "../actions/pdp-actions";

const allowedTypes = ["SHP", "PIS"];
const defaultState = "SHP";

export default function deliveryType(state = defaultState, { type, payload }) {
  switch (type) {
    case SET_DELIVERY_TYPE:
      return allowedTypes.includes(payload) ? payload : state;
    default:
      return state;
  }
}
